import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { NumberInput, NumberInputProps } from '@sato/components';

export const HookFormNumberInput = (
  props: { name: string } & NumberInputProps
) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <NumberInput {...props} {...field} error={fieldState.error?.message} />
      )}
    />
  );
};
